export const AUTH = {
  EXISTS: 'auth/exists',
  LOGIN: 'auth/login',
  LOGINAS: 'auth/loginas',
  LOGOUT: 'auth/logout',
  REGISTER: 'auth/registration',
  ACTIVATION: 'auth/email-confirmation',
  USER: 'auth/user',
  RESET: 'password/create',
  VERIFICATION: 'password/find',
  NEWPASSWORD: 'password/reset',
  CREATE_PASSWORD: {
    VERIFICATION: 'new-password/find',
    CREATE: 'new-password/create'
  },
  PERSONAL_REGISTER: 'personal/auth/registration'
}

export const USER = {
  RESOURCE: 'users',
  CREATE: 'users/create',
  ENABLE: 'users/enable',
  FORCE_DELETE: 'users/force-delete'
}

export const LOCATION = {
  RESOURCE: 'locations',
  INIT: 'locations/init',
  STREET: 'locations/city/{city}',
  FUSEBOX: 'locations/city/{city}/street/{street}'
}

export const LABEL = {
  RESOURCE: 'labels',
  FUSEBOX: 'labels/{slug}'
}

export const COMPANY = {
  RESOURCE: 'company'
}

export const FUSEBOX = {
  RESOURCE: 'fuseboxes',
  INIT: 'fuseboxes/init',
  IMAGES: 'fuseboxes/images',
  EMAIL: 'fuseboxes/email',
  GROUP: {
    RESOURCE: 'fuseboxes/{fusebox}/group',
    INIT: 'fuseboxes/{fusebox}/group/init',
    DELETE: 'fuseboxes/{fusebox}/group/{fuseboxGroup}'
  },
  GENERATE: 'pdf/{qrCode}'
}

export const PUBLIC = {
  INIT: 'public/{fusebox}/init',
  RESOURCE: 'public/{fusebox}'
}

export const DASHBOARD = 'dashboard'

export const PAYMENT = {
  PAY_RECURRING: 'pay-recurring',
  STATUS: 'payment-status',
  PLANS: 'payment-get-plans',
  SUBSCRIPTION: 'payment-subscription',
  CANCEL: 'payment-plan-cancel',
  TRANSACTION: 'transactions',
  INVOICE: 'invoices/{orderId}'
}

export const ACCESS = {
  LIST: 'fuseboxes/{fusebox}/list',
  REQUEST: 'fuseboxes/{fusebox}/request',
  GRANT: 'fuseboxes/{fusebox}/{accessRequest}/{type}',
  REVOKE: 'fuseboxes/{fusebox}/revoke'
}

export const HOME = {
  GEOCODE: '/geocode'
}

export const UTIL = {
  COUNTRY: '/country'
}
